@file:OptIn(ExperimentalResourceApi::class)

import androidx.compose.material.MaterialTheme
import androidx.compose.material.Typography
import androidx.compose.runtime.Composable
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import com.haeyum.kug_seoul.generated.resources.*
import org.jetbrains.compose.resources.ExperimentalResourceApi
import org.jetbrains.compose.resources.Font

@Composable
fun PretendardFontFamily() = FontFamily(
    Font(resource = Res.font.Pretendard_Thin, weight = FontWeight.Thin),
    Font(resource = Res.font.Pretendard_ExtraLight, weight = FontWeight.ExtraLight),
    Font(resource = Res.font.Pretendard_Light, weight = FontWeight.Light),
    Font(resource = Res.font.Pretendard_Regular, weight = FontWeight.Normal),
    Font(resource = Res.font.Pretendard_Medium, weight = FontWeight.Medium),
    Font(resource = Res.font.Pretendard_SemiBold, weight = FontWeight.SemiBold),
    Font(resource = Res.font.Pretendard_Bold, weight = FontWeight.Bold),
    Font(resource = Res.font.Pretendard_ExtraBold, weight = FontWeight.ExtraBold),
    Font(resource = Res.font.Pretendard_Black, weight = FontWeight.Black),
)

@Composable
fun KugTheme(content: @Composable () -> Unit) {
    val fontFamily = PretendardFontFamily()

    return MaterialTheme(typography = Typography(defaultFontFamily = fontFamily), content = content)
}